import * as React from "react";
import * as csstips from "csstips";
import { connect, useSelector } from "react-redux";
import { classes, style } from "typestyle";
import {
  getAuthState,
  getRouterState,
  IStoreState,
} from "../../../redux/rootReducer";
import { IGcpAppDispatchProp } from "../../../redux/store";
import {
  userClicksToAsanaTaskButton,
  userClicksToBackofficeButton,
} from "../../scenarios";
import {
  canUseAsana,
  canViewExistingControls,
  getPayloadFromToken,
} from "../../../redux/modules/auth/utils";
import ButtonLink from "../../Generics/ButtonLink";
import { getGcpRequestAsanaTaskLink } from "../utils";
import currentGcpRequestStore from "../currentGCPRequestStore";
import CsvDownloadButton from "../GcpRequestView/CsvDownloadButton";
import GpxDownloadButton from "../GcpRequestView/GpxDownloadButton";
import CsvWgsDownloadButton from "../GcpRequestView/CsvWgsDownloadButton";
import { CommentForPilot } from "./CommentForPilot/CommentForPilot";
import { Fragment } from "react";

interface ISidebarFooterProps extends IGcpAppDispatchProp {
  returnUrl?: string;
}

function SidebarFooter({ returnUrl, dispatch }: ISidebarFooterProps) {
  const { customerId, siteId } = useSelector(getRouterState).data;

  const site = currentGcpRequestStore((store) => store.site);
  // TODO: ensure that type is forwarder properly everywhere and strict null checks are enabled
  const commentForPilot: string | undefined = currentGcpRequestStore(
    (store) => store.GCPRequest?.commentForPilot,
  );
  const hasSrs = Boolean(site?.srs);

  const authState = useSelector(getAuthState);
  const { ACL } = getPayloadFromToken(authState.accessToken);
  const toShowAsanaTaskLink = canUseAsana(ACL);
  const isPilot = canViewExistingControls(ACL);

  if (!hasSrs && !returnUrl && !toShowAsanaTaskLink && !commentForPilot) {
    return null;
  }

  return (
    <Fragment>
      {commentForPilot && <CommentForPilot comment={commentForPilot} />}
      <div
        className={classes(
          "sidebar-footer",
          style({ padding: "10px 16px" }, csstips.verticallySpaced(8)),
        )}
      >
        {toShowAsanaTaskLink && (
          <ButtonLink
            stretched
            onClick={() => dispatch(userClicksToAsanaTaskButton())}
            label="To Asana GCP tasks"
            href={getGcpRequestAsanaTaskLink(customerId, siteId)}
          />
        )}

        {returnUrl && (
          <ButtonLink
            stretched
            onClick={() => dispatch(userClicksToBackofficeButton())}
            label="To Backoffice"
            href={returnUrl}
          />
        )}

        {hasSrs && (
          <>
            <div
              className={style(
                {
                  display: "flex",
                },
                csstips.horizontallySpaced(8),
              )}
            >
              <CsvDownloadButton isPilot={isPilot} />
              {!isPilot && <GpxDownloadButton />}
            </div>

            <div
              className={style(
                {
                  display: "flex",
                },
                csstips.horizontallySpaced(8),
              )}
            >
              <CsvWgsDownloadButton />
            </div>
          </>
        )}
      </div>
    </Fragment>
  );
}

export default connect((store: IStoreState) => ({
  returnUrl: getRouterState(store).data.returnUrl,
}))(SidebarFooter);
